import React from "react";
import { Route } from "react-router-dom";
import { UsadosMainScreen } from "./UsadosMainScreen";
import { ListadoPrecioScreen } from "./Inventario/ListadoPrecioScreen";
import { ListadoPreciosScreen } from "./Listado de Precios/ListadoPreciosScreen";
import { ConfiguracionImagenesScreen } from "./ConfiguracionImagenes/ConfiguracionImagenesScreen";

export const UsadosListado = () => {
    return (
        <div className="main-container">
            <Route
                path="/Usados/Main"
                component={() => <UsadosMainScreen />}
            />

            <Route
                path="/Usados/ListadoPrecios"
                component={() => <ListadoPrecioScreen />}
            />

            <Route
                path="/Usados/VisualizarListadoPrecios"
                component={() => <ListadoPreciosScreen />}
            />

            <Route
                path="/Usados/ConfiguracionImagenesMercadotecnia"
                component={() => <ConfiguracionImagenesScreen />}
            />

        </div>
    );
};
